import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.0004 16.9318V19.9318C22.0016 20.2103 21.9445 20.486 21.8329 20.7412C21.7214 20.9963 21.5577 21.2254 21.3525 21.4137C21.1473 21.602 20.905 21.7453 20.6412 21.8345C20.3773 21.9237 20.0978 21.9569 19.8204 21.9318C16.7433 21.5975 13.7874 20.546 11.1904 18.8618C8.77425 17.3265 6.72576 15.278 5.19042 12.8618C3.5004 10.253 2.44866 7.28281 2.12042 4.19182C2.09543 3.91528 2.1283 3.63658 2.21692 3.37344C2.30555 3.1103 2.44799 2.8685 2.63519 2.66344C2.82238 2.45837 3.05023 2.29453 3.30421 2.18234C3.5582 2.07015 3.83276 2.01208 4.11042 2.01182H7.11042C7.59573 2.00704 8.06621 2.17889 8.43418 2.49535C8.80215 2.8118 9.0425 3.25126 9.11042 3.73182C9.23704 4.69188 9.47187 5.63454 9.81042 6.54182C9.94497 6.89974 9.97408 7.28873 9.89433 7.6627C9.81457 8.03666 9.62928 8.37993 9.36042 8.65182L8.09042 9.92182C9.51398 12.4254 11.5869 14.4983 14.0904 15.9218L15.3604 14.6518C15.6323 14.383 15.9756 14.1977 16.3495 14.1179C16.7235 14.0382 17.1125 14.0673 17.4704 14.2018C18.3777 14.5404 19.3204 14.7752 20.2804 14.9018C20.7662 14.9703 21.2098 15.215 21.527 15.5893C21.8441 15.9636 22.0126 16.4414 22.0004 16.9318Z",
      stroke: "#0E1422",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }